

export default {
    banner: '/api/web/v2/patienteducation/ads/list',
    department_list: '/api/web/v2/patienteducation/department/list',
    disease_list: '/api/web/v2/patienteducation/disease/list',
    production_list: '/api/web/v2/patienteducation/production/list',
    company_list: '/api/web/v2/patienteducation/company/list',
    getcompayinfo:'/api/web/v2/patienteducation/company/getcompayinfo'
}
